var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import classnames from 'classnames';
import { Heading6 } from '../elements/index';
import RoundArrowButton, { RoundArrowButtonDirection } from '../round-arrow-button/RoundArrowButton';
// removed import of scss-style
import InfoButton from '../info-button/InfoButton';
import DiscrepancyIndicator from '../../components/discrepancy-indicator/DiscrepancyIndicator';
class ExpandingSection extends React.Component {
    constructor(props) {
        super(props);
        this.onResizeHandler = this.onResize.bind(this);
    }
    onResize() {
        this.updateHeight();
    }
    componentDidMount() {
        this.updateHeight();
    }
    updateHeight() {
        if (this.inner) {
            this.currentHeight = this.inner.clientHeight;
        }
    }
    componentWillMount() {
        window.addEventListener('resize', this.onResizeHandler);
        window.addEventListener('orientationchange', this.onResizeHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResizeHandler);
        window.removeEventListener('orientationchange', this.onResizeHandler);
    }
    render() {
        const _a = this.props, { className, children, caption, hasNotation, hasInfoButton, onInfoButtonClick, title } = _a, rest = __rest(_a, ["className", "children", "caption", "hasNotation", "hasInfoButton", "onInfoButtonClick", "title"]);
        const currentHeight = this.expanded ? this.currentHeight : 0;
        const onInfoClick = (e) => {
            if (onInfoButtonClick) {
                e.stopPropagation();
                onInfoButtonClick();
            }
        };
        return (React.createElement("div", Object.assign({ className: this.expanded ? classnames('ExpandingSection', className) : classnames(['hideOnPrint', 'ExpandingSection', className].join(' ')) }, rest),
            React.createElement("div", { className: 'ExpandingSection__Header RoundArrowButton__Parent', onClick: () => {
                    this.updateHeight();
                    this.expanded = !this.expanded;
                } },
                React.createElement(Heading6, null,
                    caption,
                    hasInfoButton && React.createElement(InfoButton, { small: true, onClick: onInfoClick })),
                hasNotation &&
                    React.createElement("div", { style: { pointerEvents: 'none', position: 'absolute', right: '-6.4rem' } },
                        React.createElement(DiscrepancyIndicator, { title: title })),
                React.createElement(RoundArrowButton, { direction: this.expanded
                        ? RoundArrowButtonDirection.UP
                        : RoundArrowButtonDirection.DOWN, transparent: !this.expanded })),
            React.createElement("div", { style: { height: currentHeight + 'px' }, className: classnames('ExpandingSection__Content', {
                    'ExpandingSection__Content--expanded': this.expanded
                }) },
                React.createElement("div", { ref: ref => (this.inner = ref), className: 'ExpandingSection__ContentInner' }, children))));
    }
}
__decorate([
    observable
], ExpandingSection.prototype, "expanded", void 0);
__decorate([
    observable
], ExpandingSection.prototype, "currentHeight", void 0);
export default observer(ExpandingSection);
